import { intl } from '@helpers/intl';

/**
 * Formats periodicity
 */
export const formatPeriodicity = (months: Array<number> = []): string =>
  months.length === 12
    ? intl.formatMessage({
        defaultMessage: 'N/A',
        id: 'global.value.na',
      })
    : months.map(m => intl.formatDate(new Date(2000, m - 1), { month: 'short' })).join(', ');
